__turbopack_context__.v({
  "buttonGroup": "FeaturedProject-module-scss-module__1SM9EW__buttonGroup",
  "demo": "FeaturedProject-module-scss-module__1SM9EW__demo",
  "description": "FeaturedProject-module-scss-module__1SM9EW__description",
  "details": "FeaturedProject-module-scss-module__1SM9EW__details",
  "externalLinkButtons": "FeaturedProject-module-scss-module__1SM9EW__externalLinkButtons",
  "featuredProject": "FeaturedProject-module-scss-module__1SM9EW__featuredProject",
  "featuredProjectGroup": "FeaturedProject-module-scss-module__1SM9EW__featuredProjectGroup",
  "headline": "FeaturedProject-module-scss-module__1SM9EW__headline",
  "title": "FeaturedProject-module-scss-module__1SM9EW__title",
});
